import styled from "styled-components";

export const ButtonText = styled.span`
  font-family: ${({ theme }) => theme.type.fonts.main};
  font-size: ${({ theme }) => theme.type.sizes.size16};
  font-weight: 400;
  line-height: ${({ theme }) => theme.type.sizes.size16};
  color: ${({ theme }) => theme.colours.buttonText};
`;
